<script>
import { layoutComputed } from "@/state/helpers";
import Layout from "../layouts/main";
import Heading from "../layouts/heading";
// import JsonForm from "../layouts/form";
// import api from "../../api";
import appConfig from "@/app.config";

import Home from './Home';
import Preview from './Preview';

/**
 * Dashboard component
 */
export default {
  page: {
    title: "Form Builder",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
      // JsonForm, 
      Heading,
    Home,
    Preview
  },
  data() {
    return {
      activeName: "Design",
      page: {
        title: "Form Builder",
        lastUpdated: false,
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false
      }, 
    };
  },
  methods:{
  },
  computed: {
    ...layoutComputed,
  },
  mounted() {
  }
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>

    <el-tabs v-model="activeName">
      <el-tab-pane label="Design" name="Design"><home/></el-tab-pane>
      <el-tab-pane label="Preview" name="Preview"><preview/></el-tab-pane>
    </el-tabs>
  </Layout>
</template>